// Core
import { Link, Route, Switch, Redirect, useRouteMatch, useLocation } from 'react-router-dom';
import React, { useState, useEffect }  from 'react';
import { 
  Box, 
  Flex, 
  Grid, 
  Text, 
  Menu, 
  MenuButton, 
  MenuList, 
  MenuItem, 
  Button,
  useDisclosure, 
  useBreakpointValue,
  useColorModeValue,
  useColorMode
} from '@chakra-ui/react';

// Assets
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { ReactComponent as LinesWhite } from 'assets/svg/lines-white.svg';
import { ReactComponent as LinkIcon } from 'assets/svg/partners/link.svg';

// Components
import Card from 'components/Card/Card';
import Attention from 'components/Modals/AttentionModal';
import Me from './Account';
import NotificationsCenter from './NotificationsCenter';
import Security from './Security';
import Membership from './Membership';
import Wallet from './Wallet';
import Withdraw from './Wallet/Withdraw';
import WithdrawAddAccount from './Wallet/components/AddAccount';
import TransactionHistory from './TransactionHistory';
import Sessions from './Sessions';
import MembershipSubscriptions from './Membership/components/Subscriptions';

const Account = ({ userData, userRefresh, setUserData, logoutModal }) => { 
  const bg = useColorModeValue('white', '#0A1027');
  const border = useColorModeValue('1px solid #CBE7FF', '1px solid #262D47');

  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  const { path, url } = useRouteMatch();

  const location = useLocation();
  const isActive = (path) => location.pathname.includes(path);

  const isMobile = useBreakpointValue({ base: true, md: false });
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState('Account');

  const menuItems = [
    { path: `${url}`, label: 'Account' },
    { path: `${url}/notifications-center`, label: 'Notifications Center' },
    { path: `${url}/security`, label: 'Security' },
    { path: `${url}/membership`, label: 'Membership' },
    { path: `${url}/wallet`, label: 'Wallet' },
    { path: `${url}/transaction-history`, label: 'Transaction History' },
    { path: `${url}/sessions`, label: 'Sessions' }
  ];

  useEffect(() => {
    const currentItem = menuItems.find(item => location.pathname === item.path);
    setCurrentPage(currentItem ? currentItem.label : 'Account');
  }, [location.pathname]);

  return (
    <Grid templateColumns={{ sm: '1fr', md: '0.35fr 1fr ' }} gap="0px" templateRows='1fr' 
      bg={bg} border={border} mt="32px" borderRadius="16px">
      <Box p={{base: '16px', md: '24px'}} borderRight={{ md: border}} borderBottom={{ base: border, md: 'unset'}} className="account-tabs">
        <Flex 
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          display={isMobile ? 'flex' : 'none'} alignItems="center" bg={ isDark ? '#0D234D' : 'rgba(9, 155, 255, 0.10)'} w="100%" h="56px" px="12px" borderRadius="16px" justifyContent="space-between">
          <Text color="#099BFF" fontWeight="500">{currentPage}</Text>
          <LinkIcon style={{ transform: isMobileMenuOpen ? 'rotate(-90deg)' : 'rotate(90deg)' }} />
        </Flex>

        <Box h={isMobile && !isMobileMenuOpen ? '0px' : 'auto'} pt={isMobile && isMobileMenuOpen ? '8px' : '0px'} overflow="hidden">
          {menuItems.map(({ path, label }) => (
            <Link key={path} to={path} className={location.pathname === path ? 'tab-active' : ''}>
              {label}
            </Link>
          ))}
          <Link to="#" onClick={logoutModal}>Logout</Link>
        </Box>
      </Box>

      <Box p={{base: '16px', md: '24px'}} overflow="hidden" position="relative">
        { !isActive(`${path}/membership`) && (
          isDark ? 
            <Lines className="abstract-lines" style={{zIndex: '1'}} /> 
            : <LinesWhite className="abstract-lines" style={{zIndex: '1', opacity: '0.3' }} /> 
           
        )}
        
        <Box zIndex="2" position="relative">
          <Switch>
              <Route path={`${path}/notifications-center`}  render={() => <NotificationsCenter userData={userData} />} />
              <Route path={`${path}/security`}  render={() => <Security userData={userData} />} />
              <Route path={`${path}/membership/subscriptions`}  render={() => <MembershipSubscriptions userData={userData} />} />
              <Route path={`${path}/membership`}  render={() => <Membership userData={userData} />} />
              {/*<Route path={`${path}/wallet/withdraw/add-account`}  render={() => <WithdrawAddAccount userData={userData} />} />*/}
              {/*<Route path={`${path}/wallet/withdraw`}  render={() => <Withdraw userData={userData} />} />*/}
              <Route path={`${path}/wallet`}  render={() => <Wallet userData={userData} />} />
              <Route path={`${path}/transaction-history`}  render={() => <TransactionHistory userData={userData} />} />
              <Route path={`${path}/sessions`}  render={() => <Sessions userData={userData} />} />
              <Route path={`${path}`} render={() => <Me userData={userData} userRefresh={userRefresh} setUserData={setUserData} />} />
              <Redirect from={`${path}*`} to={`${path}`} />
          </Switch>
        </Box>
      </Box>
    </Grid>
  );
};

export default Account;
